import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store'; 
import { SignalRProvider } from './context/SignalRContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SignalRProvider>
        <App />
      </SignalRProvider>
    </Provider>
  </React.StrictMode>
);